import dayjs from "dayjs";
import humanizeDuration from "humanize-duration";
import {isEmpty, isFinite, isNumber} from "underscore";

export const computeDeadline = (deadlineAt, createdAt, forTasks) => {
  const created = dayjs(createdAt);
  const deadline = dayjs(deadlineAt);

  let hours = Math.round(deadline.diff(created, "hours", true));
  const days = Math.floor(hours / 24);
  hours = hours - days * 24;

  if (forTasks) {
    return {
      days: days ? String(days) : "",
      hours: hours ? String(hours) : "",
    };
  }

  return dayjs()
    .add(days ?? 0, "days")
    .add(hours ?? 0, "hours");
};

export const computeRecurrenceValues = (recurrence) => {
  const recurrenceDays =
    isNumber(recurrence?.days) ?
      recurrence.days :
      !isEmpty(recurrence?.days) ?
        parseInt(recurrence?.days, 10) :
        0;
  const recurrenceHours =
    isNumber(recurrence?.hours) ?
      recurrence.hours :
      !isEmpty(recurrence?.hours) || isNumber(recurrence?.hours) ?
        parseInt(recurrence?.hours, 10) :
        0;

  if (!isFinite(recurrenceDays) && !isFinite(recurrenceHours)) {
    return {};
  }
  if (recurrenceDays <= 0 && recurrenceHours <= 0) {
    return {};
  }

  return {
    days: !isFinite(recurrenceDays) || recurrenceDays <= 0 ? 0 : recurrenceDays,
    hours:
      !isFinite(recurrenceHours) || recurrenceHours <= 0 ? 0 : recurrenceHours,
  };
};

export const getDurationString = (time, unit) => {
  const unitTime = humanizeDuration(time, {
    units: unit ?? "m",
    maxDecimalPoints: 2,
  });
  const fullTime = humanizeDuration(time, {maxDecimalPoints: 1});
  return (
    <>
      <span>{unitTime}</span>
      {" "}
      <span style={{fontSize: "0.8em", fontStyle: "italic"}}>
        (
        {fullTime}
        )
      </span>
    </>
  );
};

export const getTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
};
